<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Aftrekbare giften
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Giften aan algemeen nut beogende instellingen (ANBI’s) en steunstichtingen SBBI mag je van de winst aftrekken. Per
                jaar bedraagt de aftrek ten hoogste 50% van de winst, met een maximum van € 100.000. De vennootschap moet de giften
                schriftelijk kunnen bewijzen.
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Gift aan culturele ANBI
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Doet de vennootschap een gift aan een ANBI die is aangemerkt als culturele instelling? Dan mag de vennootschap de
                aftrek van de winst verhogen
                met 50%. De verhoging is echter maximaal € 2.500.
                <br/><br/>

                <div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <p><u>Voorbeeld1</u></p>
                    De vennootschap doet een gift van € 2.000 aan een culturele ANBI.
                    <br/>Een verhoging van 50% is € 1.000. De verhoging blijft onder het maximum van € 2.500. De aftrek is dus (€ 2.000
                    + € 1.000 =) € 3.000.
                </div>
                <br/>

                <div style="border: 1px solid #ccc; padding: 10px; background-color: lightgrey">
                    <p><u>Voorbeeld 2</u></p>
                    De vennootschap doet een gift van € 7.000 aan een culturele ANBI.
                    <br/>Een verhoging met 50% is € 3.500. Voor de aftrek mag je de gift echter verhogen met maximaal € 2.500. De aftrek
                    is dus (€ 7.000 + € 2.500 =) € 9.500.
                </div>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse3" aria-expanded="false" aria-controls="collapse3">
                Giften in natura
            </button>
        </h2>
        <div id="collapse3" class="accordion-collapse collapse" aria-labelledby="heading3"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Doet de vennootschap in een kalenderjaar giften in natura met een totale waarde in het economisch verkeer van meer dan € 10.000?
                Dan moet de vennootschap de waarde van de giften aantonen met een taxatierapport of een factuur. Het taxatierapport of de factuur
                moet voldoen aan een aantal voorwaarden.
                <br/><br/>
                <b>Contante gift niet aftrekbaar</b>
                <br/>
                Doet de vennootschap een gift in de vorm van contant geld? Deze gift is niet aftrekbaar.
            </div>
        </div>
    </div>
</div>
